import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/Card/view/'
export const INIT = NAMESPACE + 'INIT'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_IS_TEMPLATE = NAMESPACE + 'SET_IS_TEMPLATE'

const defaultView = {
  isLoading: false,
  isLoaded: false,
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
      return {
        ...initialState,
      }
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultView,
          ...state[action.payload.cardId],
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    case SET_IS_TEMPLATE:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          isTemplate: action.payload.isTemplate
        }
      } : state
    default: return state
  }
}

export function init ({ cardId }) {
  return {
    type: INIT,
    payload: {
      cardId
    }
  }
}

export function setLoadStatus ({ cardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      cardId,
      isLoading,
      isLoaded
    }
  }
}